import api from "./api"
import {
  CwAdminStaffResponse,
  CwAdminTask,
  CwAdminTaskWrite,
  CwAdminWorkDay,
} from "../Interfaces"
import { throwSageApiError } from "../utils/sageApiError"

function companyUrl(companyId: number) {
  if (!companyId) throw new Error("No management company id provided")
  return `/sage-100/companies/${companyId}`
}

class AdminModeService {
  public listTasks = async (companyId: number, includeInactive = true): Promise<CwAdminTask[]> => {
    try {
      const response = await api.get(`${companyUrl(companyId)}/admin-tasks`, {
        params: includeInactive ? { includeInactive: "true" } : {},
      })
      return Array.isArray(response.data) ? response.data : response.data?.data ?? []
    } catch (error) {
      throwSageApiError(error, "Could not load admin tasks.")
    }
  }

  public createTask = async (companyId: number, body: CwAdminTaskWrite): Promise<CwAdminTask> => {
    try {
      const response = await api.post(`${companyUrl(companyId)}/admin-tasks`, body)
      return response.data
    } catch (error) {
      throwSageApiError(error, "Could not add the task.")
    }
  }

  public updateTask = async (companyId: number, taskId: number, body: CwAdminTaskWrite): Promise<CwAdminTask> => {
    try {
      const response = await api.patch(`${companyUrl(companyId)}/admin-tasks/${taskId}`, body)
      return response.data
    } catch (error) {
      throwSageApiError(error, "Could not save the task.")
    }
  }

  public listStaff = async (companyId: number): Promise<CwAdminStaffResponse> => {
    try {
      const response = await api.get(`${companyUrl(companyId)}/admin-staff`)
      return {
        employees: response.data?.employees ?? [],
        users: response.data?.users ?? [],
      }
    } catch (error) {
      throwSageApiError(error, "Could not load admin staff.")
    }
  }

  /** Pass only what changes: userId (null unlinks) and/or adminModeEnabled. */
  public linkStaff = async (
    companyId: number,
    employeeId: number,
    body: { userId?: number | null, adminModeEnabled?: boolean },
  ) => {
    try {
      const response = await api.patch(`${companyUrl(companyId)}/admin-staff/${employeeId}`, body)
      return response.data
    } catch (error) {
      throwSageApiError(error, "Could not link the login.")
    }
  }

  public timeSheet = async (companyId: number, from: string, to: string): Promise<CwAdminWorkDay[]> => {
    try {
      const response = await api.get(`${companyUrl(companyId)}/admin-time-sheet`, { params: { from, to } })
      return Array.isArray(response.data) ? response.data : response.data?.data ?? []
    } catch (error) {
      throwSageApiError(error, "Could not load the admin time sheet.")
    }
  }
}

export const adminModeService = new AdminModeService()
